package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.ContentBuilder
import org.w3c.dom.HTMLButtonElement

private val button = Bem("admin-button")

/** The button variants of the design system; [SECONDARY] is the plain block. */
enum class ButtonVariant(internal val modifier: String?) {
    PRIMARY("primary"),
    SECONDARY(null),
    DANGER("danger"),
    ADD("add"),
    LINK("link"),
    ICON("icon"),
}

/**
 * A real `<button>`. Use [ButtonVariant.PRIMARY] once per view; [ButtonVariant.ICON] needs an [ariaLabel].
 */
@Composable
fun AdminButton(
    variant: ButtonVariant = ButtonVariant.SECONDARY,
    type: ButtonType = ButtonType.Button,
    disabled: Boolean = false,
    block: Boolean = false,
    ariaLabel: String? = null,
    autofocus: Boolean = false,
    /** The id of the form a submit button outside it submits, e.g. one in the page header. */
    form: String? = null,
    onClick: (() -> Unit)? = null,
    content: ContentBuilder<HTMLButtonElement>,
) {
    require(variant != ButtonVariant.ICON || ariaLabel != null) { "Icon buttons need an aria-label" }

    Button({
        type(type)
        classes(
            *listOfNotNull(
                button.block,
                variant.modifier?.let(button::modifier),
                button.modifier("block").takeIf { block },
            ).toTypedArray(),
        )
        if (disabled) {
            disabled()
        }
        ariaLabel?.let { attr("aria-label", it) }
        if (autofocus) {
            attr("autofocus", "")
        }
        form?.let { attr("form", it) }
        onClick?.let { handler -> onClick { handler() } }
    }, content)
}
